import { render } from "./Cross.vue?vue&type=template&id=7d36bd9a&ts=true"
import script from "./Cross.vue?vue&type=script&lang=ts"
export * from "./Cross.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__